import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProgramService } from '../../../core/services/program.service';
import { LocalStorageService } from '../../../core/utils/local-stoarge-service';

@Component({
    selector: 'app-time-table-item',
    templateUrl: './time-table-item.component.html',
    imports: [CommonModule,],
    styleUrls: ['./time-table-item.component.css']
})
export class TimeTableItemComponent {
@Input('myColor1') myColor1:any;
@Input('myColor2') myColor2:any;
@Input('data') data:any;
@Input('current') current:any;
@Input('index') index:any;
user:any

  constructor(
    private lsService:LocalStorageService,
  ){
    
  }

  ngOnInit(): void {
    //this.user=
  }


 hexToRgb(hex:any) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
}
